export const Roles = {
  TalentNetworkManager: "A8100A50-4440-4633-B137-1A848E927685",
  LightAdmin: "9B6CEAF8-8B2F-4A25-8403-3ECCE902ECF4",
  OutboundFeedsAdmin: "4F606859-7349-4A5A-8EC2-4780CCD5EB4E",
  SuperAdmin: "198CCA39-1161-4009-8123-49157C863384",
  JobsManager: "A9943D90-D2F8-4E06-9A92-9BF0DC2F4A38",
  ConnectBillingsAdmin: "DB6947B9-D264-4951-BAF2-BA41A5446157",
  FeedsAdmin: "7FDAABD5-80F9-4E07-BAB0-D011B2C54A1F",
  ClientAdmin: "154E1EF1-AEBF-4F95-BB04-DED92AAE0A33",
  Admin: "D4F66806-7461-40F5-AB1A-EC3131B64D44",
  EventsManager: "2728D7A9-EF2E-4652-869A-EE484DF04219",
  None: "None",
};
